// ExamStatusTable.jsx
import React from "react";
import moment from "moment";

const ExamStatusTable = ({ data, student }) => {
    // 1. Collect all unique student IDs and map to names
    const allStudentIds = new Set();
    const studentNameMap = {};

    data.forEach(item => {
        const ids = item.id_student?.split(',') || [];
        ids.forEach(id => {
            const studentObj = student.find(std => std.id === +id);
            if (studentObj) {
                allStudentIds.add(studentObj.id);
                studentNameMap[studentObj.id] = studentObj.name;
            }
        });
    });

    const uniqueStudentIds = Array.from(allStudentIds);

    // 2. Function to get status per student and exam item
    const getStatus = (id, item) => {
        const idStr = String(id);
        if (item.present?.split(',').includes(idStr)) return "P";
        if (item.absent?.split(',').includes(idStr)) return "A";
        if (item.noexam?.split(',').includes(idStr)) return "No Exam";
        if (item.holiday?.split(',').includes(idStr)) return "Holiday";
        return "-";
    };

    return (
        <div className="table-responsive mt-4">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Name</th>
                        {data.map((item, index) => (
                            <th key={index} className="text-center">
                                {moment(item.date).format("D MMM")}<br />
                                <small>{item.subject_name}</small><br />
                                <small>{item.title}</small>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {uniqueStudentIds.map(id => (
                        <tr key={id}>
                            <td>{studentNameMap[id]}</td>
                            {data.map((item, index) => (
                                <td key={index} className="text-center">{getStatus(id, item)}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ExamStatusTable;
